export default __webpack_public_path__ + "static/media/DSC_0570.f5fdcb22.jpg";